function initScrollForMoreTriggers(container) {
    const triggers = container.querySelectorAll('.scroll-for-more');

    Array.prototype.forEach.call(triggers, el => {
        el.addEventListener('click', e => {
            e.preventDefault();

            const scrollToEl = document.getElementById(el.dataset.scrollTo);

            if (scrollToEl !== null) {
                const bounds = scrollToEl.getBoundingClientRect();
                vanillaSmoothie.scrollTo(bounds.top + window.scrollY, { duration: 500, easing: 'easeInOutQuad' });
            }
        });
    });
}